import { ViewportScroller } from '@angular/common';
import { DestroyRef, DOCUMENT, inject, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';

@Service()
export class ScrollMargin {
  // Dependencies
  private destroyRef = inject(DestroyRef);
  private document = inject(DOCUMENT);
  private router = inject(Router);
  private viewportScroller = inject(ViewportScroller);

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is Scroll => event instanceof Scroll),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        // Check if the anchor is provided
        if (!event.anchor) {
          return;
        }

        // Get the element with the given id
        const element = this.document.getElementById(event.anchor);
        if (!element) {
          return;
        }

        // Get scroll margins from the element
        const scrollMarginLeft = Number.parseFloat(getComputedStyle(element).scrollMarginLeft || '0');
        const scrollMarginTop = Number.parseFloat(getComputedStyle(element).scrollMarginTop || '0');

        // Set the scroll margin offset for the viewport scroller
        this.viewportScroller.setOffset([scrollMarginLeft, scrollMarginTop]);
      });
  }
}
